export default "__VITE_ASSET__Bm5i0lxp__"